import { AxiosResponse } from "axios";
import { HttpService } from "@/services/common/HttpService";
import { LineItemsRequest, LineItemsResponse } from "@/models/dto/LineItem";

const httpService: HttpService = new HttpService();

export default {
    calculate(variant: String, body: LineItemsRequest): Promise<AxiosResponse<LineItemsResponse>> {
        const url = `/v1/coachrail/price-line-items?variant=${variant}`;
        return httpService.post(url, body);
    },
};
